import React from 'react';
import classNames from 'classnames';

import ProductList, { PropsType as ProductListPropsType } from '../ProductList';
import { HTMLZone } from '../HTMLZone/HTMLZone';
import {
  displayMiddleBannerWithSlots,
  displaySlot,
} from 'services/listing/merchandisingDisplay';
import {
  HTMLContentType,
  ProductType,
} from 'types/ProductListing/ProductListing';

import styles from './ProductListWithSlots.module.scss';

type PropsType = {
  topProducts: ProductType[];
  slots: HTMLContentType;
  middleBanners: HTMLContentType;
} & ProductListPropsType;

const BANNERS_COUNT = 3;
const SLOTS_DISPLAY = { 1: 2, 2: 6, 3: 24, 4: 38, 5: 56 };
const MIDDLE_BANNERS_DISPLAY = { 1: [17, 2], 2: [33, 3], 3: [49, 4] };

export default function ProductListWithSlots({
  products,
  renderProduct,
  topProducts,
  slots,
  middleBanners,
  ...rest
}: PropsType): JSX.Element {
  const productCount = topProducts.length + products.length;
  const slotsKeys = Object.keys(slots).map(Number);

  return (
    <ProductList products={products} renderProduct={renderProduct} {...rest}>
      {topProducts.map(product => renderProduct(product, styles.topProduct))}
      {Object.entries(slots).map(([key, value]) => (
        <HTMLZone
          key={`slot-${key}`}
          htmlContent={value}
          className={classNames(styles.slot, styles[`slot-${key}`], {
            [styles.dNone]:
              !value ||
              !displaySlot(+key, productCount, slotsKeys, SLOTS_DISPLAY),
          })}
        />
      ))}
      {[...Array(BANNERS_COUNT)].map((_, i) => {
        const index = i + 1;
        const htmlContent = middleBanners[index];
        return (
          <HTMLZone
            key={`banner-${index}`}
            htmlContent={htmlContent}
            className={classNames(styles.banner, styles[`banner-${index}`], {
              [styles.dNone]: !displayMiddleBannerWithSlots(
                index,
                productCount,
                slotsKeys,
                MIDDLE_BANNERS_DISPLAY
              ),
              [styles.vHidden]: !htmlContent,
            })}
          />
        );
      })}
    </ProductList>
  );
}
